document.addEventListener('DOMContentLoaded', function () {
  const cards = document.querySelectorAll('.collection-featured-card');

  if (!cards.length) return;

  cards.forEach(function (card) {
    const video = card.querySelector('.collection-featured-card__video');
    const toggle = card.querySelector('.collection-featured-card__sound-toggle');

    if (!video || !toggle) {
      return;
    }

    const muteIcon = toggle.querySelector('.collection-featured-card__sound-icon--off');
    const unmuteIcon = toggle.querySelector('.collection-featured-card__sound-icon--on');

    function setMutedState(isMuted) {
      video.muted = isMuted;

      if (muteIcon && unmuteIcon) {
        muteIcon.style.display = isMuted ? 'flex' : 'none';
        unmuteIcon.style.display = isMuted ? 'none' : 'flex';
      }

      toggle.setAttribute('aria-pressed', isMuted ? 'false' : 'true');
      toggle.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
    }

    // Default state: sound off
    setMutedState(true);
    toggle.style.display = 'flex';

    toggle.addEventListener('click', function (event) {
      event.preventDefault();

      const shouldUnmute = video.muted;
      setMutedState(!video.muted);

      if (shouldUnmute && video.paused) {
        video.play().catch(function () {
          // Autoplay might still be blocked; fail silently.
        });
      }
    });
  });
});